module.exports = __webpack_public_path__ + "static/img/soundMeeting.e3c80c5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/rs/soundMeeting.png
// module id = AdtU
// module chunks = 1